/**
 * Helper to resolve image URLs.
 * Handles both absolute URLs (legacy data) and relative paths (new data).
 * @param {string} path - The image path or URL.
 * @returns {string} - The full usable URL.
 */
export const getImageUrl = (path) => {
    if (!path) return '';

    // If it's already a full URL (http/https or data:image), return as is
    if (path.startsWith('http') || path.startsWith('data:')) {
        return path;
    }

    // Get API base URL from environment or default
    // We need the base domain, not the /api suffix
    const apiBase = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
    const baseUrl = apiBase.replace('/api', '');

    // Ensure path starts with /
    const cleanPath = path.startsWith('/') ? path : `/${path}`;

    return `${baseUrl}${cleanPath}`;
};
